const DICT = {
    currentStatus: [
        { label: '正常', value: '1' },
        { label: '告警', value: '2' },
        { label: '故障', value: '3' }
    ]
};
const getValue = (code, val) => {
    return (DICT[code].find(e => e.value === val) || {}).label;
};
export default {
    DICT,
    getValue
};
